const BUTTON_SELECTOR = '.button, [data-button-loading-control]';
const NAVIGATION_LOADING_SELECTOR = 'a.button[data-button-loading-on-navigation]';
const BUSY_BUTTON_SELECTOR =
  ".button[aria-busy='true'], [data-button-loading-control][aria-busy='true']";
const BUTTON_LOADING_EVENT = 'sigma:button-loading';
const NAVIGATION_RECOVERY_DELAY = 10000;

const createPixelGrid = () => {
  const spinner = document.createElement('span');
  spinner.className = 'button__spinner';
  spinner.setAttribute('aria-hidden', 'true');

  for (let index = 0; index < 9; index += 1) {
    const cell = document.createElement('span');
    cell.className = 'button__spinner-cell';
    spinner.append(cell);
  }

  return spinner;
};

const ensureLoadingStatus = (button) => {
  const existingStatus = button.querySelector('.button__loading');

  if (existingStatus) {
    return existingStatus;
  }

  const loadingLabel = button.getAttribute('data-button-loading-text') || 'Loading...';
  const loadingStatus = document.createElement('span');
  const spinner = createPixelGrid();
  const loadingText = document.createElement('span');

  loadingStatus.className = 'button__loading';
  loadingStatus.setAttribute('role', 'status');
  loadingStatus.setAttribute('aria-live', 'polite');
  loadingStatus.setAttribute('aria-atomic', 'true');
  loadingStatus.setAttribute('aria-hidden', 'true');

  loadingText.className = 'button__loading-text';
  loadingText.textContent = loadingLabel;

  loadingStatus.append(spinner, loadingText);
  button.append(loadingStatus);

  return loadingStatus;
};

const setLoading = (button, isLoading) => {
  if (isLoading) {
    const loadingStatus = ensureLoadingStatus(button);
    const loadingText = button.querySelector('.button__loading-text');
    const waitText = button.getAttribute('data-button-loading-text');

    if (loadingText && waitText) {
      loadingText.textContent = waitText;
    }

    loadingStatus?.removeAttribute('aria-hidden');
    button.setAttribute('aria-busy', 'true');
    return;
  }

  const loadingStatus = button.querySelector('.button__loading');

  button.removeAttribute('aria-busy');
  loadingStatus?.setAttribute('aria-hidden', 'true');
};

const BUTTON_CONTROLLER_KEY = Symbol.for('sigma.button-controller');

if (!window[BUTTON_CONTROLLER_KEY]) {
  window[BUTTON_CONTROLLER_KEY] = true;
  const navigationRecoveryTimers = new Map();

  const clearNavigationRecovery = (button) => {
    const timer = navigationRecoveryTimers.get(button);

    if (timer) {
      window.clearTimeout(timer);
      navigationRecoveryTimers.delete(button);
    }
  };

  const clearAllNavigationRecovery = () => {
    navigationRecoveryTimers.forEach((timer) => window.clearTimeout(timer));
    navigationRecoveryTimers.clear();
  };

  const armNavigationRecovery = (button) => {
    clearNavigationRecovery(button);

    const timer = window.setTimeout(() => {
      navigationRecoveryTimers.delete(button);
      setLoading(button, false);
    }, NAVIGATION_RECOVERY_DELAY);

    navigationRecoveryTimers.set(button, timer);
  };

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const button = event.target instanceof Element
      ? event.target.closest(NAVIGATION_LOADING_SELECTOR)
      : null;

    if (!button) {
      return;
    }

    queueMicrotask(() => {
      if (!event.defaultPrevented) {
        setLoading(button, true);
        armNavigationRecovery(button);
      }
    });
  });

  document.addEventListener('submit', (event) => {
    const button = event.submitter?.closest(BUTTON_SELECTOR);

    if (!button || button.hasAttribute('data-button-no-loading')) {
      return;
    }

    queueMicrotask(() => {
      if (!event.defaultPrevented) {
        setLoading(button, true);
        armNavigationRecovery(button);
      }
    });
  });

  document.addEventListener(BUTTON_LOADING_EVENT, (event) => {
    const button = event.target.closest?.(BUTTON_SELECTOR);

    if (!button) {
      return;
    }

    clearNavigationRecovery(button);
    setLoading(button, Boolean(event.detail?.loading));
  });

  window.addEventListener('pagehide', clearAllNavigationRecovery);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) {
      return;
    }

    clearAllNavigationRecovery();
    document.querySelectorAll(BUSY_BUTTON_SELECTOR).forEach((button) => {
      setLoading(button, false);
    });
  });
}
